import { IconSvg, IconSvgProps } from "./icon"

export default function Compass(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M12 21.167a8.357 8.357 0 1 0 0-16.714 8.357 8.357 0 0 0 0 16.714Z" />
      <path d="m12.643 17.31 2.571-7.715L7.5 12.167l3.214 1.928 1.929 3.215Z" />
    </IconSvg>
  )
}
